import React, { useMemo, useState } from 'react';
import { ArrowRightIcon, ChevronRightIcon } from 'lucide-react';
import { Product } from '../../types/catalog';
import { formatCurrency } from '../../utils/geo';
import { materialDirectory, matchesFilter } from '../../utils/catalogIndex';
interface MaterialsDirectoryProps {
  filter: string;
  onCompare: (product: Product) => void;
}
export function MaterialsDirectory({
  filter,
  onCompare
}: MaterialsDirectoryProps) {
  const [openId, setOpenId] = useState<string | null>(null);
  const groups = useMemo(materialDirectory, []);
  const visible = groups.map(group => ({
    ...group,
    items: group.items.filter(item => matchesFilter(filter, item.product.name, item.product.category, ...item.product.aliases))
  })).filter(group => group.items.length > 0);
  if (visible.length === 0) {
    return <p className="px-5 py-8 text-center text-sm text-ink-muted" data-id="element-18" data-mp="1d8az2c565oyj">No materials match.</p>;
  }
  return <div data-id="element-19" data-mp="1i7dx3cmqeux0">
      {visible.map(group => <section key={group.category} data-id="element-20" data-mp="180biypshwilh">
          <h3 className="sticky top-0 z-10 border-b border-line bg-canvas px-5 py-1.5 text-xs font-medium text-ink-soft" data-id="element-21" data-mp="17za2u6wmh5ww">
            {group.category}
          </h3>
          <ul className="divide-y divide-line" data-id="element-22" data-mp="z6q2n20omt9y">
            {group.items.map(({
          product,
          entries,
          low,
          high
        }) => {
          const open = openId === product.id;
          return <li key={product.id} data-id="element-23" data-mp="p9u1jhd459ff">
                  <button type="button" onClick={() => setOpenId(open ? null : product.id)} aria-expanded={open} className="flex w-full items-center gap-3 px-5 py-3 text-left transition-colors duration-150 hover:bg-canvas" data-id="element-24" data-mp="pavghwx92g2f">
                    <ChevronRightIcon className={`h-4 w-4 shrink-0 text-ink-soft transition-transform duration-150 ${open ? 'rotate-90' : ''}`} aria-hidden="true" data-id="element-25" data-mp="2amwu1dar5ctr" />
                    <span className="min-w-0 flex-1 truncate text-sm font-medium text-ink" data-id="element-26" data-mp="2oqcaxg6ue6jq">
                      {product.name}
                    </span>
                    <span className="tnum shrink-0 text-xs text-ink-soft" data-id="element-27" data-mp="2fsjwee8y32xe">
                      {entries.length} {entries.length === 1 ? 'plant' : 'plants'} ·{' '}
                      {low === high ? formatCurrency(low) : `${formatCurrency(low)}–${formatCurrency(high)}`}
                    </span>
                  </button>

                  {open && <div className="bg-canvas px-5 pb-3 pl-12" data-id="element-28" data-mp="2yh70atfdxm9e">
                      <ul className="divide-y divide-line" data-id="element-29" data-mp="33h31ym0m11ls">
                        {entries.map((entry, index) => <li key={`${entry.quarry.id}-${index}`} className="flex items-baseline justify-between gap-4 py-2" data-id="element-30" data-mp="1n2tpap5qd1as" data-mpi={index}>
                            <span className="min-w-0" data-id="element-31" data-mp="1khm0jlaat9zb">
                              <span className="block truncate text-sm text-ink" data-id="element-32" data-mp="1fjkh2z8yn8nb">
                                {entry.quarry.name}
                              </span>
                              <span className="block truncate text-xs text-ink-soft" data-id="element-33" data-mp="1tik4k3kqlhhw">
                                {entry.quarry.city}
                                {entry.price.note ? ` · ${entry.price.note}` : ''}
                              </span>
                            </span>
                            <span className="tnum shrink-0 text-right text-sm font-medium text-ink" data-id="element-34" data-mp="wunnkxle0k65">
                              {formatCurrency(entry.price.price)}
                              <span className="ml-1 text-xs font-normal text-ink-soft" data-id="element-35" data-mp="15tiq9zp83c4p">
                                /{entry.unit}
                              </span>
                            </span>
                          </li>)}
                      </ul>
                      <button type="button" onClick={() => onCompare(product)} className="mt-2 inline-flex items-center gap-1 text-sm font-medium text-accent transition-colors duration-150 hover:text-ink" data-id="element-36" data-mp="qsc74rhr4a38">
                        Compare by distance and 15-ton total
                        <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-37" data-mp="15it8ybyat20n" />
                      </button>
                    </div>}
                </li>;
        })}
          </ul>
        </section>)}
    </div>;
}